import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Input, ListGroup} from "reactstrap";
import {connect} from "react-redux";

class PresentationTypeTextarea extends Component {
  validate(){
    let validate = {
      valid: true,
      errors: []
    };

    return validate;
  }

  render() {
    const {value} = this.props;

    return <ListGroup style={{flexFlow: 'row wrap'}}>
      <li className="cafetery-wrap col-12">
        <Input
          type={'textarea'}
          onChange={this.props.onChange}
          value={value}
          placeholder={this.props.intl.formatMessage({id: 'question.input.placeholder.typeYourAnswer'})}
        />
      </li>
    </ListGroup>;
  }
}

PresentationTypeTextarea.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default connect(null, null, null, {withRef: true})(PresentationTypeTextarea);